import React, { FC } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";

import AssignmentDrawer from "Components/Assignment/AssignmentDrawer/AssignmentDrawer";
import {
  selectDashboardVehicleAssignmentDetail,
  selectDashboardVehicleAssignmentDetailLoading,
} from "Redux/Dashboard/slice";
import { getRoutWithId } from "Shared/Constants/routeIdenicator";
import { UNITS } from "Shared/Constants/routes";

type AssignmentDetailProps = {
  open: boolean;
  closeModal: () => void;
};

const VehicleAssignmentDetail: FC<AssignmentDetailProps> = ({
  open,
  closeModal,
}) => {
  const assignment = useSelector(selectDashboardVehicleAssignmentDetail);
  const loading = useSelector(selectDashboardVehicleAssignmentDetailLoading);
  const navigate = useNavigate();

  return (
    <AssignmentDrawer
      open={open}
      onClose={closeModal}
      assignment={assignment}
      loading={loading}
      onOpenVehicle={(id) => navigate(getRoutWithId(UNITS, id))}
    />
  );
};

export default VehicleAssignmentDetail;
